import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import HelpText from '../../../../../components/HelpText/index';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import { required } from '../../../../../utils/validation/validator';
import Validate from '../../../../../components/Validation/Validate';
import CurrencySelector from '../../../components/CurrencySelector';

export class AdditionalExpensesListItem extends React.Component {
  onDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };

  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const {
      item,
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="col-auto">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.additionalExpenseTitle}
                values={{ index: this.props.index + 1 }}
              />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.dateOfExpense}
                fieldName={messages.additionalExpensesDateOfExpense}
              >
                <DatePicker
                  disabled={disabled}
                  type="text"
                  onDayChange={this.onDayChange('dateOfExpense')}
                  value={item.dateOfExpense}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesDateOfExpense}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.description}
                fieldName={messages.additionalExpensesDescription}
              >
                <Textbox
                  disabled={disabled}
                  type="text"
                  onChange={this.onChange('description')}
                  value={item.description}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesDescription}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Train to Paris' }}
                />
              </HelpText>
            </FlexBox>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.supplier}
                fieldName={messages.additionalExpensesSupplier}
              >
                <Textbox
                  disabled={disabled}
                  type="text"
                  onChange={this.onChange('supplier')}
                  value={item.supplier}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesSupplier}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Eurostar' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amountPaid}
                fieldName={messages.additionalExpensesAmountPaid}
              >
                <Textbox
                  disabled={disabled}
                  type="number"
                  onChange={this.onChange('amountPaid')}
                  value={item.amountPaid}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesAmountPaid}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amountPaidCurrency}
                fieldName={messages.additionalExpensesCurrency}
              >
                <CurrencySelector
                  onChange={this.handleCurrencyChange('amountPaidCurrency')}
                  disabled={disabled}
                  value={item.amountPaidCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesCurrency}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
      </div>
    );
  }
}

AdditionalExpensesListItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/components/AdditionalExpenses/AdditionalExpensesListItem.js